import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

export const normalizeRegularSearchDirections = (
  directions?: DifficultRoute[] | null,
): DifficultRoute[] => {
  const first = directions?.[0]

  return first ? [first] : [{}]
}
